// Characters an email can never start with (per Django's EmailValidator), plus the quotes
// pasted addresses are often wrapped in.
const INVALID_LEADING_CHARACTERS = /^[^A-Za-z0-9!#$%&*+/=?^_{|}~-]+/;
// A domain always ends with a letter or digit.
const INVALID_TRAILING_CHARACTERS = /[^A-Za-z0-9]+$/;

/** Strips whitespace and stray punctuation around a pasted email, e.g. "omer@cargobase.com." -> "omer@cargobase.com". */
export function cleanPastedEmail(value: string): string {
  return value.trim().replace(INVALID_LEADING_CHARACTERS, "").replace(INVALID_TRAILING_CHARACTERS, "");
}
